<template>
  <div 
    class="list-product-v1 exposurer-item" 
    :data-id="data.id"
    :data-index="index"
    :data-price="data.price"
    :data-name="data.name"
    :data-rawprice="data.rawPrice"
    :data-labels="data.labels"
    :data-recommend="data.recommendEngine"
    @click="jump" >
    <swiper v-if="productImage" class="product-image" :config="swiperConfig">
      <div class="swiper-slide" v-for="(img, index) in data.images" v-key="index">
        <div class="cover-line left"></div>
        <div class="cover-line right"></div>
        <beast-image
          :lazy="true"
          :defaultImage="defaultImage"
          :src="img"
        />
        <div class="image-info" v-if="!noCorner">
          <div class="corner-box" v-if="data.foretell">
            <div class="stats-tag" :class="{big: data._big}">
              <span>即将开售</span>
            </div>
          </div>
          <div class="corner-box" v-if="data.offShelf">
            <div class="stats-tag" :class="{big: data._big}">
              <span>下架</span>
            </div>
          </div>
          <div class="corner-box" v-else-if="data.soldOut">
            <div class="stats-tag" :class="{big: data._big}">
              <span>缺货</span>
            </div>
          </div>
        </div>
      </div>
     
    </swiper>
    <!-- <div class="info summary">{{data.summary}}</div> -->
    <div class="product-infos">
      <div class="summary" v-if="data.activityDesc">{{data.activityDesc}}</div>
      <div class="tag" v-if="data.customizable">定制</div>
      <div class="tag" v-else-if="data.isOversea">跨境商品</div>
      <div class="brand-name gro-book">{{data.brand && data.brand.name}}</div>
      <div class="name">{{data.name}}</div>
      <div class="prices newn" v-if="data.mainStationFirst">
        <div class="price discount-price gro-demi"> <price v-if="data.price" :data="data.price" /><span class="newn-tag-shoudan">首单价</span></div>
        <del class="price raw-price grotesk" v-if="data.price < data.rawPrice"><price v-if="data.rawPrice" :data="data.rawPrice"/></del>
      </div>
      <div class="prices newn" v-else-if="data.newcomerTag">
        <div class="price discount-price gro-demi"> <price v-if="data.price" :data="data.price" /><span class="newn-tag">新人价</span></div>
        <del class="price raw-price grotesk" v-if="data.price < data.rawPrice"><price v-if="data.rawPrice" :data="data.rawPrice"/></del>
      </div>
      <div class="prices" v-else>
        <div class="price discount-price gro-demi"> <price v-if="data.price" :data="data.price" /></div>
        <del class="price raw-price grotesk" v-if="data.price < data.rawPrice"><price v-if="data.rawPrice" :data="data.rawPrice"/></del>
      </div>

      <div class="stock-warn" v-if="data.stockWarn">{{data.stockWarn || ''}}</div>
    </div>
    <div class="refund" v-if="data.refunds" >约返{{data.refunds | formatPrice}}元</div>
  </div>
</template>

<script>
  import price from '@/price'
  import swiper from '@/swiper/swiper-4.4.6/index.vue'
  import beastImage from '@/components/image'
  import axios from '@/axios-mock'
  import track from '@/track'
  // import { lazyload } from '@/lazyload'
  import browser from '@beastshop/browser'
  import { ensure_protocol } from '@beastshop/url-util'
  import { transformLink, trackSkip } from '@/link'
  import data from '../../activity/big-furniture/data';

  const headers = {}

  const isApp = browser.app()
  const defaultImage = ensure_protocol("http://img.thebeastshop.com/images/mcatlog/banner/p.png")

  export default {
    name: 'list-v1',

    props: {
      data: {
        require: true
      },
      float: {
        require: true
      },
      index: {
        default: false
      },
      source: {
        default: 'CART'
      },
      miniEnv: {
        default: false
      },
      noJump: {
        default: false
      },
      noCorner: {
        default: false
      },
      businessCase:{
        default: '其他'
      }
    },

    data: function () {
      return {
        defaultImage: defaultImage,
        productData: this.data,
        swiperConfig: {
          loop: true
        }
      }
    },

    components: {
      price,
      beastImage,
      swiper
    },

    created () {
      this.data.images.shift()
      this.data.images.unshift(this.data.featureImage)
    },

    mounted () {
      // console.log(this.float)
      // lazyload()
    },

    watch: {
      // data (d) {
      //   if (typeof d === 'object') {
      //     this.fit()
      //   }
      // }
    },

    computed: {
      productImage: function () {
        const data = this.data
        return data.featureImage
          ? data.featureImage
          : data.images
            ? data.images[0]
            : ''
      },

      offShelfStyle() {
        const img = ensure_protocol('http://img.thebeastshop.com/app/product/list/off-shelf-new.png')
        return `background: url(${img});background-repeat:no-repeat;background-size:cover;`
      },

      soldOutStyle() {
        const img = ensure_protocol('http://img.thebeastshop.com/app/product/list/sold-out-new.png')
        return `background: url(${img});background-repeat:no-repeat;background-size:cover;`
      }
    },
    filters: {
      formatPrice (value) {
        let v = String(Math.floor(value*Math.pow(10,1)) / Math.pow(10,1))
        const temp = v.split('.')
        return temp.length > 1 
          ? v
          : `${v}.0`
      }
    },
    methods: {
      jump (e) {
        if(this.noJump) {
          return
        }
        
        const tar = e.currentTarget
        const pindex = tar.dataset.index

        if(!this.data || !this.data.id) {
          return
        }

        let link = transformLink({
          link: {
            type: "product",
            value: this.data.id
          },
          isMini: this.miniEnv
        })
        
        let _suggestType = this.data.markInfo ? JSON.parse(this.data.markInfo).RecommendType : ''

        if (_suggestType && !this.miniEnv) {
          link += `?suggestType=${encodeURIComponent(_suggestType)}`
        }

        const trackData = {
          trackData: {
            name: this.source === 'CART' ? 'cart-suggest-product-more' : 'click-result-suggest',
            attrs: {
              productId: this.data.id,
              index: pindex,
              suggestType: _suggestType
            }
          },
          link,
          isMini: this.miniEnv
        }
        
        const prod = this.data
        const bu = prod.recommendEngine ? `${this.businessCase}-${prod.recommendEngine}`: this.businessCase
        sa.track('CommodityClick', {
          position_number: this.float,
          commodity_spu_id: prod.id,
          commodity_name: prod.name,
          original_price: prod.rawPrice,
          discount_price: prod.price,
          commodity_need_point: prod.point || 0,
          // business_case: '猜你喜欢'
          business_case: this.businessCase ? bu : '其他'
        })

        trackSkip(trackData)
      },

      fit () {
        const tagItem = document.querySelectorAll('.prices')
        const tagArr = Array.from(tagItem)
        tagArr.forEach(elem => {
          const discount = elem.querySelector('.discount-price')
          const rawcount = elem.querySelector('.raw-price')
          const tags = elem.querySelector('.tags-wrap')

          const dw = discount && discount.clientWidth || 0
          const rw = rawcount ? rawcount.clientWidth : 0
          const tw = tags && tags.clientWidth || 0

          if ((dw + rw + tw) > elem.clientWidth) {
            tags.style.display = 'none'
          }
        })
      }
    }
  }
</script>

<style scoped lang="stylus">
@import '../../common/styl/global.styl'
.newn-tag-shoudan
  position relative
  display inline-block
  top rem(0)
  width rem(40)
  height rem(17)
  margin-left rem(7)
  font-size rem(10)
  font-weight 600
  line-height rem(17)
  // border-radius rem(2)
  border solid 0.7px #C44747
  text-align center
  color #C44747
.list-product-v1
  width rem(186.5)
  min-height rem(260)
  margin-bottom rem(34)
  font-size rem(13)
  color #000000
  .swiper-slide
    position relative
    .cover-line
      position absolute
      z-index 9
      width rem(1)
      height rem(195)
      background #fff
      top 0
      &.left
        left 0
      &.right 
        right 0
  .product-image
    width 100%
    height rem(195)
    margin-bottom rem(12)
    img
      display block
      width 100%
      height 100%
    .image-info
      position relative
      top rem(-195)
      left 0
      width 100%
      height rem(195)
      .foretell-box
        position absolute
        top rem(6)
        right rem(6)
        width rem(35)
        height rem(35)
        box-sizing border-box
        border rem(1.5) solid #000000
        // background rgba(218, 229, 231, .95) none repeat scroll !important
        .foretell
          position relative
          width 100%
          top 50%
          transform translateY(-50%)
          font-size rem(10)
          line-height rem(14)
          font-weight bold
          text-align center
      // .activity-desc
      //   width 100%
      //   height rem(24)
      //   // line-height rem(17)
      //   padding 0 rem(5) rem(5)
      //   box-sizing border-box
      //   position absolute
      //   // position relative
      //   left 0
      //   bottom 0
      //   // bottom rem(22)
      //   .desc
      //     display inline-block
      //     max-width 100%
      //     // height 100%
      //     line-height rem(19)
      //     padding 0 rem(6)
      //     background #f2f2f2 none repeat scroll !important
      //     opacity 0.95
      //     box-sizing border-box
      //     color #537371
      //     font-size rem(10)
      //     font-weight bold
      //     overflow hidden
      //     text-overflow ellipsis
      //     white-space nowrap
      .corner-box
        position absolute
        top 0
        right 0
        left 0
        bottom 0
        background rgba(255, 255, 255, .6) none repeat scroll !important
        overflow hidden
        .stats-tag
          position absolute
          top rem(6)
          right rem(6)
          width rem(35)
          height rem(35)
          border rem(1.5) solid #000000
          font-size rem(10)
          font-weight bold
          text-align center
          background #ffffff
          span
            display inline-block
            position absolute
            width rem(22)
            top 50%
            left 50%
            transform translate(-50%, -50%)
          &.big
            width rem(50)
            height rem(50)
            border solid rem(2) #000
            font-size rem(14)
            span
              width rem(31)
    .add-cart
      width rem(36)
      height rem(36)
      position absolute
      right rem(9)
      bottom rem(9)
      z-index 1
  .product-infos
    width 100%
    padding 0 rem(12)
    box-sizing border-box
    line-height rem(18)
    overflow hidden
    .summary
      ellipsis()
      font-weight bold
      color #C44747
      margin-bottom rem(3)
    .tag
      ellipsis()
      font-weight bold
    .brand-name
      ellipsis()
      line-height rem(16)
    .name
      ellipsis()
    .prices
      float left
      margin-top rem(3)
      ellipsis()
      clearfix()
      width auto!important
      &.newn
        .discount-price
          float none 
          display block
        .raw-price
          float none
          display block
      .price
        font-size rem(13)
        float left
        line-height rem(16)
        .decimal
          font-size rem(10)
      .newn-tag
        display inline-block
        width rem(37)
        height rem(16)
        margin-left rem(5)
        font-size rem(9)
        font-weight bold
        line-height rem(16)
        border-radius rem(2)
        text-align center
        background #F5F5F5
        color #DD4F14
        &::before
          content ''
          display inline-block
          vertical-align middle
          width 0
          height 100%
          margin-top rem(1)
      .raw-price
        color #C9C9C9
        font-size rem(11)
        float left
        line-height rem(16)
        margin-left rem(8)
  .stock-warn
    float left
    margin-left rem(6)
    padding-top rem(3)!important
    font-weight bold
    font-size rem(12)
    color #c44747
  .refund
    display inline-block
    margin-left rem(14)
    margin-top rem(5)
    padding rem(3) rem(5)
    border solid rem(1) #C44747
    font-size rem(10)
    font-weight bold
    color #C44747
</style>



// WEBPACK FOOTER //
// index.vue?4c503f96